import React from 'react';
import { Box, type BoxProps } from '@mui/material';

interface ListLayoutPanelProps extends Omit<BoxProps, 'children'> {
  children: React.ReactNode;
}

const ListLayoutPanel: React.FC<ListLayoutPanelProps> = ({
  children,
  sx,
  ...props
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: "#f9fafb",
        overflowX: 'auto',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default ListLayoutPanel;